import ApplicationController from '../application_controller'

class StepsController extends ApplicationController {
  static targets = ['allRequired', 'mandatory']

  connect () {
    this.handleAllRequiredTarget()
  }

  handleAllRequiredTarget () {
    if (!this.hasAllRequiredTarget || !this.hasMandatoryTarget) return

    const mandatoryInput = this.mandatoryTarget
    const allRequiredInput = this.allRequiredTarget
    const toggleField = () => {
      if (mandatoryInput.checked) {
        this.enableField(allRequiredInput)
      } else {
        this.disableField(allRequiredInput)
      }
    }

    toggleField()

    mandatoryInput.addEventListener('change', toggleField)
  }

  enableField (field) {
    field.removeAttribute('disabled')
  }

  disableField (field) {
    field.setAttribute('disabled', true)
    field.checked = false
  }
}

export default StepsController
